// src/pages/attendance/config/translations.js

export const translations = {
  ar: {
    pageTitle: "نظام الحضور والانصراف",
    timeTracker: {
      checkIn: "تسجيل الحضور", checkOut: "تسجيل الانصراف",
      alreadyCheckedIn: "تم تسجيل الحضور بالفعل", notCheckedIn: "لم يتم تسجيل الحضور",
      processingCheckIn: "جاري تسجيل الحضور...", processingCheckOut: "جاري تسجيل الانصراف...",
      inZone: "داخل منطقة العمل", outOfZone: "خارج منطقة العمل",
      locationError: "خطأ في تحديد الموقع", tryAgain: "حاول مرة أخرى",
      refreshLocation: " تحديث الموقع", refreshing: " جاري التحديث...",
      distanceToCenter: "المسافة من المركز",
      loadingLocation: "جاري تحميل موقع العمل...", gettingLocation: "جاري تحديد موقعك...",
      withinZone: " داخل المنطقة", outZone: " خارج المنطقة",
    },
    stats: {
      presentDays: "أيام الحضور", absentDays: "أيام الغياب",
      lateArrivals: "مرات التأخير", totalHours: "إجمالي الساعات", thisMonth: "هذا الشهر",
    },
    weekDays: {
      Sunday: "الأحد", Monday: "الاثنين", Tuesday: "الثلاثاء", Wednesday: "الأربعاء",
      Thursday: "الخميس", Friday: "الجمعة", Saturday: "السبت",
    },
    weekly: {
      title: "حضور هذا الأسبوع", weekend: "عطلة", restDay: "يوم راحة",
      in: "دخول:", out: "خروج:", present: "حاضر", absent: "غائب", late: "متأخر",
      summary: "ملخص الأداء الأسبوعي", presentDaysCount: "أيام الحضور",
      lateArrivalsCount: "مرات التأخير", absentDaysCount: "أيام الغياب", totalHoursCount: "إجمالي الساعات",
    },
    performance: {
      title: "مقاييس الأداء", attendanceRate: "معدل الحضور", punctuality: "الالتزام بالمواعيد",
      avgHoursPerDay: "متوسط الساعات/اليوم", overtimeHours: "ساعات إضافية",
      current: "الحالي:", target: "الهدف:",
    },
    monthly: {
      title: "سجل الحضور الشهري", month: "الشهر", presentDays: "أيام الحضور",
      absentDays: "أيام الغياب", lateDays: "أيام التأخير", totalDays: "إجمالي الأيام",
      attendanceRate: "معدل الحضور", performance: "الأداء",
    },
    recent: {
      title: "السجلات الأخيرة", date: "التاريخ", checkIn: "وقت الدخول",
      checkOut: "وقت الخروج", totalHours: "إجمالي الساعات", status: "الحالة", complete: "مكتمل",
    },
    status: { present: "حاضر", absent: "غائب", late: "متأخر", weekend: "عطلة", Complete: "مكتمل", onLeave: "في إجازة", leave: "في إجازة", "On Leave": "في إجازة", rest_day: "يوم راحة", "Rest Day": "يوم راحة", holiday: "إجازة رسمية", half_day: "نصف يوم" },
    units: { hours: "ساعة", meters: "متر" },
    workFromHome: {
      requestButton: "طلب العمل من المنزل", modalTitle: "طلب العمل من المنزل",
      selectDate: "اختر التاريخ", reason: "سبب الطلب",
      reasonPlaceholder: "اكتب سبب طلب العمل من المنزل...",
      submit: "إرسال الطلب", cancel: "إلغاء", submitting: "جاري الإرسال...",
      success: "تم إرسال طلب العمل من المنزل بنجاح", error: "فشل في إرسال الطلب",
      pending: "طلب العمل من المنزل قيد الانتظار", approved: "تمت الموافقة على العمل من المنزل",
      rejected: "تم رفض طلب العمل من المنزل", workingFromHome: "تعمل من المنزل اليوم",
      locationBypassed: "اشتغل من البيت",
    },
  },
  en: {
    pageTitle: "Attendance System",
    timeTracker: {
      checkIn: "Check In", checkOut: "Check Out",
      alreadyCheckedIn: "Already Checked In", notCheckedIn: "Not Checked In",
      processingCheckIn: "Processing Check In...", processingCheckOut: "Processing Check Out...",
      inZone: "Inside Work Zone", outOfZone: "Outside Work Zone",
      locationError: "Location Error", tryAgain: "Try Again",
      refreshLocation: " Refresh Location", refreshing: " Refreshing...",
      distanceToCenter: "Distance from Center",
      loadingLocation: "Loading work location...", gettingLocation: "Getting your location...",
      withinZone: " Within Zone", outZone: " Outside Zone",
    },
    stats: {
      presentDays: "Present Days", absentDays: "Absent Days",
      lateArrivals: "Late Arrivals", totalHours: "Total Hours", thisMonth: "This Month",
    },
    weekDays: {
      Sunday: "Sunday", Monday: "Monday", Tuesday: "Tuesday", Wednesday: "Wednesday",
      Thursday: "Thursday", Friday: "Friday", Saturday: "Saturday",
    },
    weekly: {
      title: "This Week's Attendance", weekend: "Weekend", restDay: "Rest Day",
      in: "In:", out: "Out:", present: "Present", absent: "Absent", late: "Late",
      summary: "Weekly  Summary", presentDaysCount: "Present Days",
      lateArrivalsCount: "Late Arrivals", absentDaysCount: "Absent Days", totalHoursCount: "Total Hours",
    },
    performance: {
      title: "Performance Metrics", attendanceRate: "Attendance Rate", punctuality: "Punctuality",
      avgHoursPerDay: "Avg Hours/Day", overtimeHours: "Overtime Hours",
      current: "Current:", target: "Target:",
    },
    monthly: {
      title: "Monthly Attendance Record", month: "Month", presentDays: "Present Days",
      absentDays: "Absent Days", lateDays: "Late Days", totalDays: "Total Days",
      attendanceRate: "Attendance Rate", performance: "Performance",
    },
    recent: {
      title: "Recent Records", date: "Date", checkIn: "Check In Time",
      checkOut: "Check Out Time", totalHours: "Total Hours", status: "Status", complete: "Complete",
    },
    status: { present: "Present", absent: "Absent", late: "Late", weekend: "Weekend", Complete: "Complete", onLeave: "On Leave", leave: "On Leave", "On Leave": "On Leave", rest_day: "Rest Day", "Rest Day": "Rest Day", holiday: "Holiday", half_day: "Half Day" },
    units: { hours: "hours", meters: "m" },
    workFromHome: {
      requestButton: "Request Work From Home", modalTitle: "Work From Home Request",
      selectDate: "Select Date", reason: "Reason for Request",
      reasonPlaceholder: "Enter reason for working from home...",
      submit: "Submit Request", cancel: "Cancel", submitting: "Submitting...",
      success: "Work from home request submitted successfully", error: "Failed to submit request",
      pending: "Work from home request pending", approved: "Work from home approved",
      rejected: "Work from home request rejected", workingFromHome: "Working from home today",
      locationBypassed: "Location check bypassed",
    },
  },
};